import React, { useCallback, useEffect, useState, useRef, useMemo } from 'react';
import { Row, Col, Button, Grid, Carousel } from 'antd';
import { useSelector } from 'react-redux';
import indexStyles from '../index.less';
import { JoinClassName } from 'src/utils/utils';

const { useBreakpoint } = Grid;

const CommonGetDemoTopSection = ({ title, desc, descHtml, className, children, outerClassName = '' }) => {
  const screens = useBreakpoint();
  return (
    <React.Fragment>
      <div
        className={JoinClassName(
          indexStyles.commonTopSectionWrapper,
          outerClassName,
          screens.xs ? indexStyles.forMobile : '',
          screens.md ? indexStyles.forMDDevice : '', //768
          screens.sm && !screens.md ? indexStyles.forSMDevice : '' //576
        )}
      >
        <div
          className={JoinClassName(
            indexStyles.commonSection,
            title ? '' : indexStyles.commonSectionNoHeader,
            className,
            screens.xs ? indexStyles.mobile : ''
          )}
        >
          <Row align={'middle'} justify={'center'} wrap={false}>
            <Col xs={19} md={12}>
              <h1 className={JoinClassName(indexStyles.title_h1)}>{title}</h1>
            </Col>
          </Row>

          <Row align={'middle'} justify={'center'} wrap={false}>
            <Col xs={22} md={12}>
              {descHtml ? (
                <h2
                  className={JoinClassName(indexStyles.commonTopDesc)}
                  dangerouslySetInnerHTML={{ __html: descHtml }}
                />
              ) : desc ? (
                <h2 className={JoinClassName(indexStyles.commonTopDesc)}>{desc}</h2>
              ) : null}
            </Col>
          </Row>

          <Row align={'middle'} justify={'center'} wrap={false}>
            <Col xs={24}>{children}</Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export const CommonGetDemoTopSectionOnLeft = ({ title, desc, descHtml, className, children, outerClassName = '' }) => {
  const screens = useBreakpoint();
  return (
    <React.Fragment>
      <div
        className={JoinClassName(
          indexStyles.commonTopSectionWrapper,
          outerClassName,
          screens.xs ? indexStyles.forMobile : '',
          screens.md ? indexStyles.forMDDevice : '', //768
          screens.sm && !screens.md ? indexStyles.forSMDevice : '' //576
        )}
      >
        <div
          className={JoinClassName(
            indexStyles.commonSection,
            title ? '' : indexStyles.commonSectionNoHeader,
            className,
            screens.xs ? indexStyles.mobile : ''
          )}
        >
          <Row align={'flex-start'} justify={'center'} wrap={false}>
            <Col xs={24}>
              <h1
                className={JoinClassName(indexStyles.title_h1)}
                style={{ justifyContent: 'flex-start', textAlign: 'left' }}
              >
                {title}
              </h1>
            </Col>
          </Row>

          <Row align={'flex-start'} justify={'center'} wrap={false}>
            <Col xs={24}>
              {descHtml ? (
                <p
                  className={JoinClassName(indexStyles.commonTopDesc)}
                  style={{ justifyContent: 'flex-start', textAlign: 'left', alignItems: 'flex-start' }}
                  dangerouslySetInnerHTML={{ __html: descHtml }}
                ></p>
              ) : (
                <p
                  className={JoinClassName(indexStyles.commonTopDesc)}
                  style={{ justifyContent: 'flex-start', textAlign: 'left', alignItems: 'flex-start' }}
                >
                  {desc}
                </p>
              )}
            </Col>
          </Row>

          <Row align={'flex-start'} justify={'center'} wrap={false}>
            <Col xs={24}>{children}</Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CommonGetDemoTopSection;
